// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { OnAfterCodeLoad } from "@lg/shared";
import { BoInfoSymbol, HasChangedInternallySymbol } from "@lg/shared/for-apps";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared/for-apps";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => MarginType.loadInternal(), entryList => {
        MarginType.θentryList.set(entryList)
        MarginType.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class MarginType {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label"] as const,
        allPropertyNames: ["id", "label"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<MarginType.Id | null>;
    static readonly Id = String;
    static ids: MarginType.Id[] = [] as any;
    static idsAndDisplayValues: Record<MarginType.Id, string> = {} as any;
    static θentryList = signal<MarginType.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<MarginType.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? MarginType.getEntryMap()[id]?.label : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return MarginType[BoInfoSymbol]
    }

    get __type(): 'Orders.MarginType' {
        return 'Orders.MarginType'
    }

    set __type(_) {
    }

    static get __type(): 'Orders.MarginType' {
        return 'Orders.MarginType'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): MarginType.Id | null {
        return this.θid()
    }

    set id(id: MarginType.Id | MarginType | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !MarginType.getEntry(id as MarginType.Id)) throw new Error('Invalid id for type Orders.MarginType: ' + id)
        this.θid.set(id as MarginType.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): MarginType.Id[] {
        return MarginType.ids
    }

    get idsAndDisplayValues(): Record<MarginType.Id, string> {
        return MarginType.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[MarginType.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get isPercentage() {
        return this.id == 'percentage'
    }

    static get Percentage() {
        return new this('percentage')
    }

    get isFixedAmount() {
        return this.id == 'fixedAmount'
    }

    static get FixedAmount() {
        return new this('fixedAmount')
    }

    constructor(idOrObject: MarginType.Id | MarginType | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): MarginType.Entry[] {
        return This.MarginType.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): MarginType.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: MarginType.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof MarginType.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = MarginType.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<MarginType.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new MarginType(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: MarginType.Id | MarginType | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as MarginType.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: MarginType.Id | MarginType) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<MarginType.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Orders.MarginType yet:', err.message)
            //throw err
        })
    }

    setPercentage() {
        this.id = 'percentage'

    }

    setFixedAmount() {
        this.id = 'fixedAmount'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "percentage", label: "Percentage" }),
            Object.freeze({ id: "fixedAmount", label: "Fixed Amount" })
        ] as MarginType.Entry[]) as MarginType.Entry[]
    }
}
jsonClass('Orders.MarginType')(MarginType)

export const MarginTypeθId = String;

export type MarginTypeθId = string;

export namespace MarginType {
    export type Id = 'percentage' | 'fixedAmount'

    export interface Entry {
        id: MarginType.Id;
        label: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => MarginType.load(true))
